var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8529 2.16C26.228 3.54036 27 5.40924 27 7.3575C27 9.30576 26.228 11.1746 24.8529 12.555L13.4964 24L2.13995 12.555C1.11868 11.527 0.423384 10.2206 0.141099 8.79934C-0.141186 7.37811 0.00208171 5.9052 0.552968 4.56499C1.10385 3.22478 2.03788 2.07682 3.23812 1.26482C4.43837 0.45282 5.8515 0.0128538 7.30061 0C9.23833 0.0117554 11.093 0.788041 12.4613 2.16C12.8603 2.55484 13.2081 2.99832 13.4964 3.48C13.7847 2.99832 14.1325 2.55484 14.5315 2.16C15.2057 1.47608 16.0091 0.932989 16.8951 0.562296C17.781 0.191603 18.7318 0.000708103 19.6922 0.000708103C20.6526 0.000708103 21.6034 0.191603 22.4894 0.562296C23.3753 0.932989 24.1787 1.47608 24.8529 2.16Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.4784d6849eeef6ba56cff04050ed2459.svg";
export { ForwardRef as ReactComponent };